import React, { useContext } from 'react';
import './Emergency.scss';
import { Link } from 'react-router-dom';
import emergencyImage from '../../assets/newmonaassets/image_samet_caring.jpg';
import { LanguageContext } from '../../context/LanguageContext';

const Emergency = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className="emergency-section" data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="emergency-img-wrapper">
                            <div className="emergency-img">
                                <img src={emergencyImage} alt={t('altText.doctorExamination')} />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="emergency-content">
                            <span className="subtitle">{t('emergency.sectionTitle')}</span>
                            <h2>{t('emergency.title')}</h2>
                            <p>{t('emergency.description')}</p>
                            <div className="appointment-btn">
                                <Link to="/contact">{t('emergency.appointmentButton')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Emergency;